import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse,HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap, finalize  } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { LoadingService } from './loading.service';
import { environment } from '../environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private router: Router, private loadingService: LoadingService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler) : Observable<HttpEvent<any>> {


    // Verifica se a requisição é para a URL excluída
    if (!req.url.includes(environment.apiUrl)) {
      // Se não contiver, passa a requisição sem modificações
      return next.handle(req);
    }

    this.loadingService.show();

    const token = localStorage.getItem('token');
    //console.log('Interceptor token', token )
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone; // Obtém o timezone do navegador

    
    if (token) {
      // const cloned = req.clone({
      //   headers: req.headers.set('Authorization', `Bearer ${token}`)
      // });
      
      const cloned = req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
            'X-Timezone': timezone, // Mantém o timezone nas requisições autenticadas
          }
        });
      
      return next.handle(cloned).pipe(
        tap(event => {
          //console.log('Interceptor event', event)
          if (event instanceof HttpResponse) {
            //console.log('Interceptor event', event.headers.get('X-Api-Version'))
            const apiVersion = event.headers.get('X-Api-Version');
            const environment = event.headers.get('X-Environment');
            if (apiVersion) {
              localStorage.setItem('apiVersion', apiVersion);
            }
            if (environment) {
              localStorage.setItem('environment', environment);
            }
          }
        }),
        finalize(() => this.loadingService.hide()),
        catchError((error: HttpErrorResponse) => {
          // Handle your error here
          console.error('*************** Error from interceptor:', error);
          console.error('*************** Error Status:', error.status);
          if (error.status === 400 ) {
            // Handle your 400  errors here
            Swal.fire({
              title : 'Atenção',
              text : error.error.Message,
              icon : 'warning',
              customClass : {
                confirmButton : 'btn btn-primary icon',
              }
            })
          }
          else if (error.status === 401 ) {
            // Handle your 401 errors here
            Swal.fire({
              title : 'Atenção',
              html : '<p>Voce nao tem acesso a essa funcionalidade</p>',
              icon : 'warning',
              customClass : {
                confirmButton : 'btn btn-primary icon',
              }
            })
            localStorage.clear();
            this.router.navigateByUrl("/auth/login");
          }
          else if (error.status === 0) {
            this.router.navigateByUrl('/error');
            return throwError(error);
          }
          else
          {
            Swal.fire({
              title : 'Atenção',
              html : '<p>Infelizmente ocorreu um erro inesperado, tente novamente mais tarde.</p>',
              icon : 'error',
              customClass : {
                confirmButton : 'btn btn-primary icon',
              }
            })
          }
          
          return throwError(error);
        })
        
      );
    } else {
      return next.handle(req).pipe(
        tap(event => {
         //console.log('Interceptor event', event)
          if (event instanceof HttpResponse) {
            //console.log('Interceptor event', event.headers.get('X-Api-Version'))
            const apiVersion = event.headers.get('X-Api-Version');
            const environment = event.headers.get('X-Environment');
            if (apiVersion) {
              localStorage.setItem('apiVersion', apiVersion);
            }
            if (environment) {
              localStorage.setItem('environment', environment);
            }
          }
        }),
        finalize(() => this.loadingService.hide()),
        catchError((error: HttpErrorResponse) => {
          // Handle your error here
          console.error('####################### Error from interceptor:', error);
          if (error.status === 400 ) {
            // Handle your 400  errors here
            Swal.fire({
              title : 'Atenção',
              text : error.error.Message,
              icon : 'warning',
              customClass : {
                confirmButton : 'btn btn-primary icon',
              },
            })
            //alert(error.error.message);
          }
          else if (error.status === 401  ) {
            // Handle your  401 errors here
            Swal.fire({
              title : 'Atenção',
              html : '<p>Voce nao tem acesso a essa funcionalidade</p>',
              icon : 'warning',
              customClass : {
                confirmButton : 'btn btn-primary icon',
              },
            })
            localStorage.clear();
            this.router.navigateByUrl("/auth/login");
            //alert('Voce nao tem acesso a essa funcionalidade');
          }
          else if (error.status === 0) {
            this.router.navigateByUrl('/error');
            return throwError(error);
          }
          else
          {
            Swal.fire({
              title : 'Atenção',
              html : '<p>Infelizmente ocorreu um erro inesperado, tente novamente mais tarde.</p>',
              icon : 'error',
              customClass : {
                confirmButton : 'btn btn-primary icon',
              },
            })
          }
          return throwError(error);
        })
      );;
    }
  }
}
